export const getNameInitials = ({ firstName, lastName }) => `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`;
const nbsp = String.fromCharCode(160);
export const getFullName = ({ firstName, lastName }) => [firstName, lastName].filter(Boolean).join(nbsp);
export const getExtendedUserName = (name) => [getFullName(name), ...(name.preferredName ? [`(${name.preferredName})`] : [])].join(nbsp);
//# sourceMappingURL=name.js.map